export const ADD_ACTION = "add";

export const VIEW_ACTION = "view";

export const EDIT_ACTION = "edit";
